<app-header [title]="'my_sales.register_new_sale_label' | translate" [backLinkText]="'my_sales.come_back_to_my_sales' | translate"
            [backLinkGtmLabel]="'link_go-back-to--my-sales'" (onBackLinkClick)="navigateToMySales()"></app-header>
<!-- Contenedor principal con ancho máximo y padding responsive -->

<ng-container *ngIf="isFabricatorForm || isDistributorForm">
    <div class="px-4 sm:px-6 lg:px-8 py-8">
        <app-fabricator-select-invoices
            [saleId]="saleId"
            (onSelectedInvoices)="onSaveFabricatorForm($event)"
        ></app-fabricator-select-invoices>
    </div>
</ng-container>

<ng-container *ngIf="!isFabricatorForm && !isDistributorForm && needToSelectShop !== undefined">
    <div *ngIf="needToSelectShop" class="px-4 sm:px-6 lg:px-8 py-8">
        <div class="bg-white px-6 sm:px-8 lg:px-10 py-6 sm:py-8">
            <h1 class="m-0 typography-title-m">
                {{'my_sales.select_your_shop' | translate}}
            </h1>
            <div class="border-b border-border-disabled mt-3 mb-8"></div>
            <div class="p-0 md:px-16">
                <label for="shopSelector" class="typography-body-m-medium">
                    {{'my_sales.select_your_shop' | translate}}
                </label>
                <div class="mt-2">
                    <app-select
                        [placeholder]="'my_sales.select_your_shop' | translate"
                        [options]="shopList"
                        [selectedValue]="selectedShop"
                        [searchable]="false"
                        (selectedValueChanged)="onShopSelected($event)"
                    ></app-select>
                </div>
            </div>
            <div class="mt-4 p-0 md:px-16">
                <p class="m-0 mb-1 typography-body-m-regular">
                    {{'my_sales.your_proactivity_pays_off' | translate}}
                </p>
                <alert type="warning">
                    {{'my_sales.old_sales_do_not_generate_actios' | translate: {varDays: ACTIOS_CUT_OFF_DAYS} }}
                </alert>
            </div>
        </div>
        <div class="bg-white mt-6 px-4 sm:px-6 py-4 flex flex-col justify-end md:flex-row md:items-center gap-3">
            <div>
                <app-button
                    (click)="onShopConfirmed()"
                    [primary]="true"
                    [isFullWidth]="true"
                    [disabled]="!canContinueToSalesCreation"
                    class="md:w-auto"
                >
                    {{ 'my_sales.continue_button' | translate }}
                </app-button>
            </div>
        </div>
    </div>
    <div *ngIf="!needToSelectShop" class="">
        <div class="px-4 sm:px-6 lg:px-8 py-8">

            <!-- Barra de progreso -->
            <div class="mb-6">
                <app-progress-bar
                    [steps]="progressSteps"
                    [currentStep]="step"
                    orientation="horizontal"
                    [showDescription]="true">
                </app-progress-bar>
            </div>

            <!-- Step 1: Add/Edit Applications -->
            <div *ngIf="step === 1">
                <div *ngIf="step !== 1 || addedApplications.length > 0"
                     class="bg-white px-6 sm:px-8 lg:px-10 py-6 sm:py-8">
                    <div *ngIf="addedApplications.length > 0">
                        <span class="typography-title-m slds-size_1-of-1 padding-title mb-0">
                            {{ 'my_sales.step_summary_title' | translate }}
                        </span>
                        <div class="header mt-0 mb-6"></div>

                        <div
                            class="inputs grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6">
                            <!-- Tarjeta de aplicación -->
                            <div *ngFor="let app of addedApplications; let i = index"
                                 class="p-8 gap-2 flex flex-col bg-[#f3f5fc] h-full min-h-64 md:min-h-72 lg:min-h-80">
                                <div class="font-medium mb-2 text-center">{{ getApplicationLabel(app.application) }}
                                </div>

                                <img [src]="getColorThumb(app)" alt="Material"
                                     class="w-24 h-24 object-cover mb-2 mx-auto" />

                                <div class="text-sm text-center">{{ app.color }}</div>
                                <div class="text-sm font-medium text-center">{{ app.brand }}</div>

                                <div *ngIf="app.units" class="text-sm mt-1 text-center">
                                    {{ 'global.units' | translate }}:&nbsp;<strong>{{ app.units }}</strong>
                                </div>

                                <div
                                    class="flex justify-between text-sm colorDeleteAndEdit mt-auto pt-2 border-t border-gray-200">
                                    <button class="hover:underline text-inherit bg-transparent p-0 border-0"
                                            gtmLabel="step1--new-sale_card_delete-application"
                                            (click)="deleteApplication(i)">{{ 'global.delete' | translate }} ✕
                                    </button>
                                    <button class="hover:underline text-inherit bg-transparent p-0 border-0"
                                            gtm-label="step1--new-sale_card_edit-application"
                                            (click)="editApplication(i)">{{ 'my_sales.edit' | translate }} ✎
                                    </button>
                                </div>
                            </div>

                            <!-- Card para añadir nueva aplicación -->
                            <ng-container *ngIf="!addingNew">
                                <div
                                    class="flex flex-col items-center justify-center border-2 border-solid p-4 sm:p-5 lg:p-6 cursor-pointer hover:bg-blue-50 transition-colors
                       bg-[#f3f5fc] h-full min-h-64 md:min-h-72 lg:min-h-80 add-card"
                                    style="border-color:#365bca;"
                                    gtm-label="step1--new-sale_card_add-application"
                                    (click)="addNewApplication()">
                                    <img src="assets/icons/add.svg" alt="Upload" class="h-[50px]" />
                                    <span class="typography-title-m mt-2 text-center text-[#365bca]">
                                        {{ 'my_sales.add_application' | translate }}
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <!-- Form de alta/edición de aplicación -->
                <div *ngIf="addingNew" class="bg-white px-6 sm:px-8 lg:px-10 py-6 sm:py-8 mt-6">
                    <span class="typography-title-m slds-size_1-of-1 padding-title mb-0">
                        {{ editingIndex !== null ? ('my_sales.edit_application_title' | translate) : ('my_sales.add_application_title' | translate) }}
                    </span>
                    <div class="header mt-0 mb-6"></div>

                    <div class="inputs grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6 mb-6">
                        <div>
                            <label class="form-label typography-body-m-medium">
                                {{ 'my_sales.application_label' | translate }}
                            </label>
                            <div class="mt-2">
                                <app-select
                                    placeholder="{{ 'my_sales.application_Placeholder' | translate }}"
                                    [searchable]="false"
                                    [selectedValue]="selectedApplication"
                                    [options]="applicationOptions"
                                    (selectedValueChanged)="selectApplication($event)">
                                </app-select>
                            </div>
                        </div>


                        <div *ngIf="showUnits()">
                            <label class="form-label typography-body-m-medium">
                                {{ 'my_sales.units_label' | translate }}
                            </label>
                            <div class="mt-2">
                                <app-select
                                    placeholder="{{ 'my_sales.units_Placeholder' | translate }}"
                                    [searchable]="false"
                                    [selectedValue]="selectedUnits"
                                    [options]="unitsOptions"
                                    (selectedValueChanged)="selectUnits($event)">
                                </app-select>
                            </div>
                        </div>
                    </div>

                    <div class="inputs grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
                        <div>
                            <label class="form-label typography-body-m-medium">
                                {{ 'my_sales.brand_label' | translate }}
                            </label>
                            <div class="mt-2">
                                <app-select
                                    placeholder="{{ 'my_sales.brand_Placeholder' | translate }}"
                                    [searchable]="false"
                                    [selectedValue]="selectedBrand"
                                    [options]="brandOptions"
                                    (selectedValueChanged)="selectBrands($event)">
                                </app-select>
                            </div>
                        </div>

                        <div>
                            <label class="form-label typography-body-m-medium">
                                {{ 'my_sales.color_label' | translate }}
                            </label>
                            <div class="mt-2">
                                <app-select
                                    placeholder="{{ 'my_sales.color_Placeholder' | translate }}"
                                    [searchable]="true"
                                    [selectedValue]="selectedColor"
                                    [options]="colorOptions"
                                    (selectedValueChanged)="selectColor($event)">
                                </app-select>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Step 2: Invoice Details -->
            <div *ngIf="step === 2">
                <div class="bg-white px-6 sm:px-8 lg:px-10 py-6 sm:py-8">
                    <span class="typography-title-m slds-size_1-of-1 padding-title mb-0">
                        {{ 'my_sales.invoice_details_title' | translate }}
                    </span>
                    <div class="header mt-0 mb-6"></div>

                    <!-- Professional and Team Member Selection -->
                    <div class="inputs grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6 mb-6">

                        <div>
                            <label class="form-label typography-body-m-medium">
                                {{ 'my_sales.select_professional_label' | translate }}
                            </label>
                            <div class="mt-2">
                                <app-select
                                    placeholder="{{ 'my_sales.select_professional_label' | translate }}"
                                    [searchable]="false"
                                    [selectedValue]="selectedProfessional"
                                    [options]="professionalOptions"
                                    (selectedValueChanged)="selectProfessional($event)">
                                </app-select>
                            </div>
                        </div>

                        <div>
                            <label class="form-label typography-body-m-medium">
                                {{ 'my_sales.select_team_member_label' | translate }}
                            </label>
                            <div class="mt-2">
                                <app-select
                                    placeholder="{{ 'my_sales.select_team_member_label' | translate }}"
                                    [searchable]="false"
                                    [selectedValue]="selectedTeamMember"
                                    [options]="teamMemberOptions"
                                    (selectedValueChanged)="selectTeamMember($event)">
                                </app-select>
                            </div>
                        </div>

                    </div>

                    <!-- Invoice Date -->
                    <div class="mb-6">
                        <div class="inputs grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
                            <div>
                                <label class="form-label typography-body-m-medium">
                                    {{ 'my_sales.indicate_invoice_date_label' | translate }}
                                </label>
                                <div class="mt-2">
                                    <mat-form-field class="w-full border border-divider ">
                                        <input
                                            class="typography-body-m-regular placeholder:!text-text-tertiary !tracking-normal"
                                            matInput [matDatepicker]="picker" [(ngModel)]="invoiceDateValue"
                                            [max]="maxInvoiceDate"
                                            readonly
                                            (click)="picker.open()"
                                            [placeholder]="'my_sales.indicate_invoice_date_label' | translate">

                                        <mat-datepicker-toggle [disableRipple]="true" matIconSuffix [for]="picker">
                                            <mat-icon matDatepickerToggleIcon>
                                                <img src="assets/icons/datepicker.svg" alt="date" />
                                            </mat-icon>
                                        </mat-datepicker-toggle>

                                        <mat-datepicker #picker
                                                        (yearSelected)="invoiceDateValue?.getFullYear()"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="invoiceDateError" class="text-red-600 text-xs mt-1">
                                    {{ 'my_sales.invalid_date_error' | translate }}
                                </div>
                            </div>
                            <div *ngIf="isInvoiceDateOverLimit()">
                                <alert [fullHeight]="true" [type]="'warning'">
                                    {{ 'my_sales.old_sales_do_not_generate_actios' | translate: { varDays: ACTIOS_CUT_OFF_DAYS } }}
                                </alert>
                            </div>
                        </div>
                    </div>

                    <!-- Drag & Drop con label -->
                    <div class="marginComponents">
                        <label class="form-label typography-body-m-medium mb-2 sm:mb-3">
                            {{ 'my_sales.attach_invoice_label' | translate }}
                        </label>

                        <div
                            class="mt-2 relative flex cursor-pointer flex-col items-center justify-center border border-dashed border-border-secondary
                   p-4 transition-colors hover:border-blue-300 hover:bg-background-light-00"
                            (dragover)="onDragOver($event)"
                            (dragleave)="onDragLeave()"
                            (drop)="onDrop($event)"
                            (click)="!uploadDisabled && onOpenFileSelect()"
                            [class.bg-background-medium-01]="isDragging"
                            [class.opacity-50]="uploadDisabled"
                            [class.cursor-not-allowed]="uploadDisabled"
                            [class.pointer-events-none]="uploadDisabled"
                            [attr.aria-disabled]="uploadDisabled"
                            [attr.title]="uploadDisabled ? 'Ya hay un archivo adjunto' : null">

                            <div
                                class="flex flex-col items-center justify-center gap-2 min-h-[108px] pointer-events-none">
                                <ng-container *ngIf="!isDragging">
                                    <img src="assets/icons/upload.svg" alt="Upload"
                                         class="h-[32px] pointer-events-none" />
                                    <div class="typography-title-s pointer-events-none">
                                        {{ 'my_sales.drag_drop_invoice' | translate }}
                                    </div>
                                    <div class="flex flex-col items-center justify-center gap-1 pointer-events-none">
                                        <div
                                            class="typography-body-s-regular text-text-tertiary text-center pointer-events-none">
                                            {{ 'my_sales.supported_formats' | translate }}
                                        </div>
                                        <div
                                            class="typography-body-s-regular text-text-tertiary text-center pointer-events-none">
                                            {{ 'my_sales.possible_formats' | translate }}
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="isDragging">
                                    <div class="typography-title-s text-primary-700 pointer-events-none">
                                        {{ 'my_sales.drop_the_file_you_want_to_upload_here' | translate }}
                                    </div>
                                    <div class="typography-body-s-regular text-center pointer-events-none">
                                        {{ 'my_sales.drag_and_drop_the_file_in_this_box' | translate }}
                                    </div>
                                </ng-container>
                            </div>

                            <input
                                type="file"
                                #fileInput
                                class="absolute inset-0 h-full w-full opacity-0 pointer-events-none"
                                accept="image/png,image/jpeg,application/pdf,.png,.jpg,.jpeg,.pdf"
                                hidden
                                [disabled]="uploadDisabled"
                                (change)="onFileSelected($event)" />
                        </div>
                    </div>

                    <!-- Archivo adjunto debajo del dropzone -->
                    <div *ngIf="uploadedInvoices.length > 0" class="marginComponents pt-4">
                        <div class="relative bg-white px-4 py-3 w-full box-border md:w-1/3"
                             style="border: none; box-shadow: none;">
                            <div class="flex items-center gap-3">
                                <img class="w-5 h-5 flex-shrink-0" src="assets/icons/document2.svg" alt="Document">

                                <div class="flex-1 min-w-0 flex flex-row items-center gap-2">
                                    <div class="text-sm font-medium truncate">
                                        {{ uploadedInvoices[0].name }}
                                    </div>
                                    <div class="text-xs text-gray-500 whitespace-nowrap" style="max-width: none;">
                                        {{ (uploadedInvoices[0].size / 1024) | number:'1.0-2' }} kb
                                    </div>
                                </div>

                                <div (click)="deleteInvoice(0)" class="cursor-pointer hover:bg-background-light-00">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M4.79844 13.725L4.27344 13.2L8.47344 9.00002L4.27344 4.80002L4.79844 4.27502L8.99844 8.47502L13.1984 4.27502L13.7234 4.80002L9.52344 9.00002L13.7234 13.2L13.1984 13.725L8.99844 9.52502L4.79844 13.725Z"
                                            fill="#365BCA" />
                                    </svg>
                                </div>
                            </div>

                            <div class="pl-8 mt-2 flex items-center justify-between">
                                <a class="text-blue-600 hover:underline cursor-pointer flex items-center"
                                   (click)="previewInvoice(uploadedInvoices[0])">
                                    {{ 'my_sales.download' | translate }}
                                    <img class="w-5 h-5 flex-shrink-0 ml-1" src="assets/icons/download.svg"
                                         alt="Download">
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Error Message -->
                    <div *ngIf="uploadError" class="text-red-600 text-sm mt-4 text-center">
                        {{ uploadError | translate }}
                    </div>

                    <!-- GDPR Notice -->
                    <div class="marginComponents">
                        <alert *ngIf="!warrantyFormMode" [type]="'info'" [icon]="true" class="p-4 mt-6">
                            {{ 'my_sales.gdpr_notice' | translate }}
                        </alert>
                    </div>
                    <!-- Terms and Conditions -->
                    <div class="marginComponents">
                        <app-checkbox [checked]="acceptTerms" (checkboxChange)="acceptTerms = $event">
                            <a [href]="termsAndConditionsLink" target="_blank"
                               rel="noopener noreferrer" class="text-blue-600 hover:underline">
                                {{ 'my_sales.accept_terms_label' | translate }}
                            </a>
                        </app-checkbox>
                    </div>
                </div>
            </div>

            <!-- Step 3: Activate Warranty -->
            <div *ngIf="step === 3">
                <div class="bg-white px-6 sm:px-8 lg:px-10 py-6 sm:py-8">
                    <span class="typography-title-m slds-size_1-of-1 padding-title mb-0">
                        {{ 'my_sales.confirmation_title' | translate }}
                    </span>

                    <div class="space-y-6">
                        <div class="header"></div>

                        <!-- Alert info -->
                        <div *ngIf="salePoints" class="marginComponents">
                            <alert *ngIf="!warrantyFormMode" [type]="'warning'" [icon]="true">
                                {{ 'my_sales.approval_message' | translate: {varPoints: salePoints} }}
                            </alert>
                        </div>
                        <!-- Warranty Options + Promo -->
                        <ng-container *ngIf="!warrantyFormMode">
                            <div class="inputs grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
                                <label
                                    [ngClass]="{'is-active': selectedWarrantyOption === 'activate'}"
                                    class="block bg-background-light-00 p-6 cursor-pointer transition hover-active-box">
                                    <div class="flex flex-col items-center text-center gap-3">
                                        <input type="radio" name="warrantyOption" class="form-radio"
                                               [(ngModel)]="selectedWarrantyOption" value="activate" />
                                        <img src="assets/icons/verified.svg" alt="Activate warranty"
                                             class="w-12 h-12" />
                                        <h4 class="text-sm font-semibold text-gray-800">
                                            {{ 'my_sales.activate_now' | translate }}
                                        </h4>
                                        <p class="typography-body-s-medium">
                                            {{ 'my_sales.activate_description' | translate }}
                                        </p>
                                    </div>
                                </label>

                                <label
                                    [ngClass]="{'is-active': selectedWarrantyOption === 'instructions'}"
                                    class="block bg-background-light-00 p-6 cursor-pointer transition hover-active-box">
                                    <div class="flex flex-col items-center text-center gap-3">
                                        <input type="radio" name="warrantyOption" class="form-radio"
                                               [(ngModel)]="selectedWarrantyOption" value="instructions" />
                                        <img src="assets/icons/mail.svg" alt="Send instructions" class="w-12 h-12" />
                                        <h4 class="text-sm font-semibold text-gray-800">
                                            {{ 'my_sales.send_instructions' | translate }}
                                        </h4>
                                        <p class="typography-body-s-medium">
                                            {{ 'my_sales.instructions_description' | translate }}
                                        </p>
                                    </div>
                                </label>
                            </div>
                        </ng-container>

                        <!-- FORMULARIO DE GARANTÍA -->
                        <div *ngIf="warrantyFormMode !== null" class="bg-white rounded-md px-4 sm:px-6 lg:px-8">
                            <span class="typography-body-m-light">
                                {{
                                    warrantyFormMode === 'activate'
                                        ? ('my_sales.warranty_form_title' | translate)
                                        : ('my_sales.send_instructions_title' | translate)
                                }}
                            </span>

                            <!-- Alerta solo para instrucciones -->
                            <alert *ngIf="warrantyFormMode === 'instructions'" type="info" [icon]="true">
                                {{ 'my_sales.instructions_gdpr_warning' | translate }}
                            </alert>

                            <!-- FORMULARIO REDUCIDO -->
                            <div *ngIf="warrantyFormMode === 'instructions'" class="space-y-4 mt-4">
                                <div class="mt-2">
                                    <app-radio [checked]="warrantyForm.instructionOption === 'mail'"
                                               (onClick)="warrantyForm.instructionOption = 'mail'">
                                        <span
                                            class="typography-body-m-regular text-sm">{{ 'my_sales.send_instructions_mail' | translate }}</span>
                                    </app-radio>
                                </div>
                                <div>
                                    <label class="form-label">{{ 'my_sales.customer_email' | translate }}*</label>

                                    <div class="flex mt-2">
                                        <input
                                            #instrEmail="ngModel"
                                            id="instructionsEmail"
                                            class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                            type="email"
                                            email
                                            required
                                            [placeholder]="'customer@example.com'"
                                            [disabled]="warrantyForm.instructionOption !== 'mail'"
                                            [(ngModel)]="warrantyForm.email"
                                        />
                                    </div>
                                    <div
                                        *ngIf="warrantyForm.instructionOption === 'mail' && instrEmail.invalid && (instrEmail.dirty || instrEmail.touched || submitAttempted)"
                                        class="error-text text-xs mt-1">
                                        <ng-container *ngIf="instrEmail.errors?.['email']; else reqInstr">
                                            {{ 'my_sales.email_format_invalid' | translate : {} : '' || 'Invalid email format' }}
                                        </ng-container>
                                        <ng-template #reqInstr>
                                            {{ 'my_sales.email_required' | translate : {} : '' || 'Required field' }}
                                        </ng-template>
                                    </div>
                                </div>
                                <div class="mt-1">
                                    <app-checkbox [disabled]="warrantyForm.instructionOption !== 'mail'"
                                                  [checked]="warrantyForm.gdprConfirmation"
                                                  (checkboxChange)="warrantyForm.gdprConfirmation = $event">
                                        <span class="typography-body-m-regular text-sm">
                                            {{ 'my_sales.gdpr_checkbox_label' | translate }}
                                            <a [href]="warrantyConditionsLink" target="_blank"
                                               class="text-blue-600 underline">
                                                {{ 'my_sales.assignment_link' | translate }}
                                            </a>
                                        </span>
                                    </app-checkbox>
                                </div>
                                <div class="mt-1">
                                    <app-checkbox [disabled]="warrantyForm.instructionOption !== 'mail'"
                                                  [checked]="warrantyForm.clientApproval"
                                                  (checkboxChange)="warrantyForm.clientApproval = $event">
                                        <span class="typography-body-m-regular text-sm">
                                            {{ 'my_sales.client_approval_checkbox' | translate }}
                                        </span>
                                    </app-checkbox>
                                </div>

                                <div class="mt-2">
                                    <app-radio [checked]="warrantyForm.instructionOption === 'pdf'"
                                               (onClick)="warrantyForm.instructionOption = 'pdf'; resetClientInstructionsWarrantyCheckboxes($event)">
                                        <span
                                            class="typography-body-m-regular text-sm">{{ 'my_sales.download_instructions_pdf' | translate }}</span>
                                    </app-radio>
                                </div>

                            </div>

                            <!-- Warranty Form -->
                            <div *ngIf="warrantyFormMode === 'activate'"
                                 class="bg-white px-4 sm:px-6 lg:px-8 py-6 space-y-6">
                                <alert type="info" [icon]="true">
                                    <span class="typography-body-m-regular mb-1">
                                        {{ 'my_sales.data_protection_compliance' | translate }}
                                    </span>
                                    <ol class="text-xs list-decimal pl-4 space-y-1 typography-body-m-regular text-gray-800">
                                        <li>{{ 'my_sales.warranty_point_1' | translate }}</li>
                                        <li>{{ 'my_sales.warranty_point_2' | translate }}</li>
                                        <li>{{ 'my_sales.warranty_point_3' | translate }}</li>
                                    </ol>
                                </alert>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.name' | translate }}*
                                        </label>
                                        <div class="flex mt-2">
                                            <input
                                                class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                                type="text"
                                                maxlength="100"
                                                [placeholder]="'my_sales.name_placeholder' | translate"
                                                [(ngModel)]="warrantyForm.name"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.surname' | translate }}*
                                        </label>
                                        <div class="flex mt-2">
                                            <input
                                                class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                                type="text"
                                                maxlength="50"
                                                [placeholder]="'my_sales.surname_placeholder' | translate"
                                                [(ngModel)]="warrantyForm.surname"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.country' | translate }}*
                                        </label>

                                        <div class="mt-2">
                                            <app-select
                                                placeholder="{{ 'my_sales.country_placeholder' | translate }}"
                                                [searchable]="true"
                                                [selectedValue]="selectedCountry"
                                                [options]="countries"
                                                (selectedValueChanged)="onCountryChange($event)">
                                            </app-select>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.zip' | translate }}*
                                        </label>

                                        <div class="mt-2" *ngIf="userInfo">
                                            <app-select-postal
                                                [userInfo]="userInfo"
                                                [country]="warrantyForm.country"
                                                (postalSelected)="onWarrantyPostalSelected($event)"
                                            ></app-select-postal>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.state' | translate }}*
                                        </label>
                                        <div class="flex mt-2">
                                            <input
                                                class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                                type="text"
                                                maxlength="100"
                                                [placeholder]="'my_sales.state_placeholder' | translate"
                                                [(ngModel)]="warrantyForm.state"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.city' | translate }}*
                                        </label>

                                        <div class="flex mt-2">
                                            <input
                                                class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                                type="text"
                                                maxlength="100"
                                                [placeholder]="'my_sales.city_placeholder' | translate"
                                                [(ngModel)]="warrantyForm.city"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.address' | translate }}*
                                        </label>

                                        <div class="flex mt-2">
                                            <input
                                                class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                                type="text"
                                                maxlength="255"
                                                [placeholder]="'my_sales.address_placeholder' | translate"
                                                [(ngModel)]="warrantyForm.address"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.email' | translate }}*
                                        </label>

                                        <div class="flex mt-2">
                                            <input
                                                #activateEmail="ngModel"
                                                class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                                type="email"
                                                email
                                                name="activateEmail"
                                                [placeholder]="'my_sales.email_placeholder' | translate"
                                                [(ngModel)]="warrantyForm.email"
                                                required
                                            />
                                        </div>

                                        <div
                                            *ngIf="activateEmail.invalid && (activateEmail.dirty || activateEmail.touched || submitAttempted)"
                                            class="error-text text-xs mt-1">
                                            <ng-container *ngIf="activateEmail.errors?.['email']; else reqAct">
                                                {{ 'my_sales.email_format_invalid' | translate : {} : '' || 'Invalid email format' }}
                                            </ng-container>
                                            <ng-template #reqAct>
                                                {{ 'my_sales.email_required' | translate : {} : '' || 'Required field' }}
                                            </ng-template>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.phone' | translate }}*
                                        </label>

                                        <div class="flex mt-2">
                                            <input
                                                class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                                type="text"
                                                maxlength="20"
                                                [placeholder]="'my_sales.phone_placeholder' | translate"
                                                [(ngModel)]="warrantyForm.phone"
                                            />
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label typography-body-m-medium">
                                            {{ 'my_sales.invoice_date' | translate }}*
                                        </label>

                                        <div class="flex mt-2">
                                            <input
                                                class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                                type="date"
                                                [placeholder]="'my_sales.surname_placeholder' | translate"
                                                [(ngModel)]="invoiceDateString"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="flex flex-col gap-4 mt-4">
                                    <app-checkbox [checked]="warrantyForm.gdprConfirmation"
                                                  (checkboxChange)="warrantyForm.gdprConfirmation = $event">
                                        <span class="typography-body-m-regular text-sm">
                                            {{ 'my_sales.gdpr_checkbox_label' | translate }}
                                            <a [href]="warrantyFormLink" target="_blank" class="text-blue-600 underline">
                                            {{ 'my_sales.assignment_link' | translate }}
                                        </a>
                                        </span>
                                    </app-checkbox>

                                    <app-checkbox [checked]="warrantyForm.clientApproval"
                                                  (checkboxChange)="warrantyForm.clientApproval = $event">
                                        <span class="typography-body-m-regular text-sm">
                                            {{ 'my_sales.client_approval_checkbox' | translate }}
                                        </span>
                                    </app-checkbox>

                                </div>
                            </div>
                        </div>
                    </div>
                </div> <!-- /wrapper step 3 -->

                <!-- Promo Banner: US/CA Retail only -->
                <div *ngIf="isUserFromUsaCa && isRetailUser" class="mt-6">
                    <a [href]="salesBannerPdfUrl"
                       target="_blank" rel="noopener noreferrer">
                        <picture>
                            <source media="(min-width: 1025px)" [srcset]="salesBannerDesktopUrl" />
                            <img [src]="salesBannerTabletUrl"
                                 alt="Shop & Save promotion"
                                 class="w-full h-auto rounded" />
                        </picture>
                    </a>
                </div>

            </div> <!-- /step 3 -->

            <!-- Navigation Buttons -->
            <div
                class="bg-white mt-6 px-4 sm:px-6 py-4 flex flex-col md:flex-row md:justify-between md:items-center gap-3">
                <div>
                    <app-button
                        *ngIf="(addingNew && editingIndex === null && addedApplications.length > 0) || step == 2"
                        (click)="goBack()"
                        [primary]="false"
                        [isFullWidth]="true"
                        class="md:w-auto"
                        [gtmLabel]="'step2--new-sale_button_previous-step'"
                    >
                        {{ 'my_sales.previous_step_button' | translate }}
                    </app-button>
                </div>

                <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                    <div *ngIf="(step === 1 || step === 2) && !addingNew && addedApplications.length > 0">
                        <app-button [ghost]="true" (click)="saveDraft(false)" [isFullWidth]="true" class="md:w-auto">
                            {{ 'my_sales.save_draft_button' | translate }}
                        </app-button>
                    </div>
                    <div *ngIf="(step === 3)">
                        <app-button [ghost]="true" (click)="goBack()"
                                    [isFullWidth]="true"
                                    [gtmLabel]="!warrantyFormMode ? 'step3--new-sale_button_go-back-to--my-sales' : 'step4--new-sale_button_go-back-to--my-sales'"
                                    class="md:w-auto">
                            {{ 'global.back' | translate }}
                        </app-button>
                    </div>

                    <div>
                        <app-button
                            [primary]="true"
                            (click)="onSaveAndContinue()"
                            [disabled]="!canContinue()"
                            [isFullWidth]="true"
                            class="md:w-auto"
                        >
                            {{
                                addingNew
                                    ? ('my_sales.save_application_button' | translate)
                                    : (step === progressSteps.length && warrantyFormMode !== null
                                        ? ('my_sales.finalizar' | translate)
                                        : ('my_sales.continue_button' | translate))
                            }}
                        </app-button>
                    </div>
                </div>
            </div>

        </div> <!-- /container -->
    </div> <!-- /bg -->

</ng-container>

<!-- Finish Modal -->
<div
    *ngIf="showFinishModal"
    class="finish-modal__overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="finishModalTitle"
    (click)="closeFinishModal()"
>
    <div class="finish-modal__panel" (click)="$event.stopPropagation()">
        <button
            class="finish-modal__close"
            type="button"
            aria-label="Close"
            (click)="closeFinishModal()"
        >
            ×
        </button>

        <ng-container *ngIf="warrantyFormMode === 'activate' || warrantyFormMode === null">
            <span id="finishModalTitle" class="typography-title-m">
                {{ 'my_sales.register_warranty_modal_final_thanks_title' | translate : {} : '' || 'Thank you for registering the warranty' }}
            </span>

            <p class="typography-body-l-regular">
                {{ 'my_sales.register_warranty_modal_final_thanks_subtitle' | translate : {} : '' || 'Your customer will receive an email with the registered warranty, to verify your information.' }}
            </p>
        </ng-container>

        <ng-container *ngIf="warrantyFormMode === 'instructions'">
            <span id="finishModalTitle" class="typography-title-m">
                {{ 'my_sales.register_warranty_modal_final_thanks_title_no_warranty' | translate : {} : '' || 'Thank you for registering your sale' }}
            </span>

            <p class="typography-body-l-regular">
                {{ 'my_sales.register_warranty_modal_final_thanks_subtitle_no_warranty' | translate : {} : '' || 'When your customer completes the warranty registration process, you will be able to download it here' }}
            </p>
        </ng-container>


        <div class="finish-modal__actions">
            <app-button
                [primary]="true"
                (click)="navigateToMySales()"
            >
                {{ 'my_sales.come_back_to_my_sales' | translate : {} : '' || 'Return to My Sales' }}
            </app-button>
        </div>
    </div>
</div>

<app-confirm-modal
    [isOpen]="isConfirmActivateWarrantyModalOpen"
    title="{{ 'my_sales.abandon_warranty_registration_modal_title' | translate }}"
    message="{{
    ('my_sales.abandon_warranty_registration_modal_desc_1' | translate) + ' ' +
    ('my_sales.abandon_warranty_registration_modal_desc_2' | translate) + ' ' +
    ('my_sales.abandon_warranty_registration_modal_desc_3' | translate)
}}"
    confirmText="{{'my_sales.activate_warranty' | translate}}"
    cancelText="{{'my_sales.come_back_to_my_sales' | translate}}"
    [buttonsInRow]="true"
    (onConfirm)="isConfirmActivateWarrantyModalOpen = false"
    (onCancel)="navigateToMySales()"
    (onClose)="isConfirmActivateWarrantyModalOpen = false"
/>
